import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@app/shared/auth/auth.guard';
import { RetailerComponent } from './pages/retailer/retailer.component';

const routes: Routes = [
  {
    path: '',
    component: RetailerComponent,
    canActivate: [AuthGuard],
  },
];

export const RetailerRoutingModule = RouterModule.forChild(routes);
